<template>
<div class="templates">
    <div class="container">
        <slot></slot>
        <h3  class="d-block d-lg-none text-center text-white text-capitalize mb-4">{{ category }} Templates</h3>
        <div class="templates-tabs">
            <a @click="category='projects'" class="templates-tab" :class="category == 'projects' ? 'active' : ''">
                <span class="d-inline-block">
                    <img v-lazy="'/img/new-homepage/template-icons/projects-icon-w.svg'" class="mr-0 mr-lg-2" alt="Templates for Organizing Projects">
                </span>
                <span class="d-none d-lg-inline-block">Projects</span>
            </a>
            <a @click="category='agency'" class="templates-tab" :class="category == 'agency' ? 'active' : ''">
                <span class="d-inline-block">
                    <img v-lazy="'/img/new-homepage/template-icons/agency-icon-w.svg'" class="mr-0 mr-lg-2" alt="Templates for Agency Organization">
                </span>
                <span class="d-none d-lg-inline-block">Agency</span>
            </a>
            <a @click="category='marketing'" class="templates-tab" :class="category == 'marketing' ? 'active' : ''">
                <span class="d-inline-block">
                    <img v-lazy="'/img/new-homepage/template-icons/marketing-icon-w.svg'" class="mr-0 mr-lg-2" alt="Templates for Marketing Management">
                </span>
                <span class="d-none d-lg-inline-block">Marketing</span>
            </a>
            <a @click="category='sales'" class="templates-tab" :class="category == 'sales' ? 'active' : ''">
                <span class="d-inline-block">
                    <img v-lazy="'/img/new-homepage/template-icons/sales-icon-w.svg'" class="mr-0 mr-lg-2" alt="Templates for Sales Process Optimization">
                </span>
                <span class="d-none d-lg-inline-block">Sales</span>
            </a>
            <a @click="category='product'" class="templates-tab" :class="category == 'product' ? 'active' : ''">
                <span class="d-inline-block">
                    <img v-lazy="'/img/new-homepage/template-icons/product-icon-w.svg'" class="mr-0 mr-lg-2" alt="Templates for Product Management">
                </span>
                <span class="d-none d-lg-inline-block">Product</span>
            </a>
            <a @click="category='personal'" class="templates-tab" :class="category == 'personal' ? 'active' : ''">
                <span class="d-inline-block">
                    <img v-lazy="'/img/new-homepage/template-icons/personal-icon-w.svg'" class="mr-0 mr-lg-2" alt="Templates for Personal Tasks">
                </span>
                <span class="d-none d-lg-inline-block">Personal</span>
            </a>
        </div>
        <div class="swiper-container templates-swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="singleTemplate in templatesList" :key="singleTemplate.index">
                    <div class="swiper-image">
                        <div class="row align-items-center template-slider-wrapper">
                            <div class="col-lg-6">
                                <h3  class="d-block d-lg-none text-center" style="margin-bottom: 15px;">{{ singleTemplate.title }}</h3>
                                <img width="100%" :src="singleTemplate.img" :alt="singleTemplate.alt">
                                <!-- <div class="d-flex d-lg-none template-cta preview-template mr-0 mx-auto mt-3" @click="template = singleTemplate; showModal = true;">
                                    <span class="ic-arrow mr-2 mb-1"></span> Preview Template
                                </div> -->
                                <!-- <a :href="singleTemplate.link" class="d-block d-lg-none mt-3 template-cta hvr-grow mx-auto"> <span class="ic-arrow mr-2 mb-1"></span> Use this template</a> -->
                            </div>
                            <div class="col-lg-6">
                                <div  class="d-block d-lg-none swiper-pagination organize mb-0"></div>
                                <h3 class="d-none d-lg-block mt-4 mt-lg-0">{{ singleTemplate.title }}</h3>
                                <p class="pre-formatted">{{ singleTemplate.content }}</p>
                                <div class="template-cta preview-template try-template-btn-dark mr-3" @click="template = singleTemplate; showModal = true;">
                                    <span class="ic-arrow mr-2 mb-1"></span> Preview Template
                                </div>
                                <!-- <a :href="`https://app.startinfinity.com/fwd/template-start/${ singleTemplate.uid }`" target="_blank" class="d-none d-lg-flex template-cta hvr-grow"> <span class="ic-arrow mr-2 mb-1"></span> Use this template</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="arrows container">
                <div class="swiper-button-next templates-swiper-button-next">
                    <span class="ic-arrow"></span>
                </div>
                <div class="swiper-button-prev templates-swiper-button-prev">
                    <span class="ic-arrow"></span>
                </div>
            </div>
        </div>
        <div class="d-none d-lg-block swiper-pagination templates-swiper-pagination organize"></div>
    </div>
    <div v-if="template !== null && showModal == true" class="try-it-modal d-block">
        <div class="modal-top-bar">
            This is a preview <span @click="showModal = false" class="ic-exit"></span>
        </div>
        <embed :src="`https://app.startinfinity.com/b/${ template.uid }?pretend`" width="100%" style="border: 0; margin-bottom: -8px; background-color: #fff;">
        <div class="modal-bottom-bar">
            <div class="modal-template">
                <!-- <img :src="template.image" :alt="template.name"> -->
                <span class="d-inline-block content">
                    <div class="title">
                        {{ template.title }}
                    </div>
                    <!-- <div class="content">
                        {{ template.featured ? 'Framework' : template.meta_description }}
                    </div> -->
                </span>
            </div>
            <a :href="`https://app.startinfinity.com/fwd/template-start/${ template.uid }`" target="_blank" class="use-this-template-btn ml-auto">Use This Template <span class="ml-2 ic-arrow"></span></a>
        </div>
    </div>
</div>
</template>
<script>
import Swiper from 'swiper';
import templates from '../../../../public/js/home/templates-v2.json';
export default {
    props: ['h2'],
    data() {
        return {
            swiper: null,
            category: 'projects',
            templates: templates,
            template: null,
            showModal: false
        };
    },
    computed: {
        templatesList() {
            return templates[this.category];
        },
        bgColor() {
            if(this.category === 'projects') {
                return '#47BEFF';
            } else if (this.category === 'agency') {
                return '#FF7289';
            } else if (this.category === 'marketing') {
                return '#1BDFBB';
            } else if (this.category === 'sales') {
                return '#FFC033';
            } else if (this.category === 'product') {
                return '#CC97FF';
            } else if (this.category === 'personal') {
                return '#FF9957';
            }
        }
    },
    mounted() {
        const that = this;
        this.swiper = new Swiper('.templates-swiper-container', {
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            simulateTouch: true,
            keyboard: true,
            loop: true,
            spaceBetween: 10,
            pagination: {
                el: '.templates-swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.templates-swiper-button-next',
                prevEl: '.templates-swiper-button-prev'
            },
            on: {
                slideNextTransitionStart() {
                    if (this.slides.length-1 === this.activeIndex) {
                        const categories = Object.keys(that.templates);
                        const currentIndex = categories.findIndex(cat => cat === that.category);

                        let newIndex = currentIndex + 1;

                        if (newIndex === categories.length) {
                            newIndex = 0;
                        }

                        that.category = categories[newIndex];
                    }

                },
                slidePrevTransitionStart() {
                    if (this.activeIndex === 0) {
                        const categories = Object.keys(that.templates);
                        const currentIndex = categories.findIndex(cat => cat === that.category);
                        let newIndex = currentIndex - 1;
                        if (newIndex === -1) {
                            newIndex = categories.length -1;
                        }
                        that.category = categories[newIndex];
                        this.activeIndex = this.slides.length - 1;
                    }
                }
            }
        });
    },
    methods: {
        changeCategory() {
            if(this.swiper.slides.length-1 === this.swiper.realIndex) {
                const categories = Object.keys(this.templates);
                const currentIndex = categories.findIndex(cat => cat === this.category);

                let newIndex = currentIndex + 1;

                if (newIndex === categories.length) {
                    newIndex = 0;
                }

                this.category = categories[newIndex];
            }
        },
        showTemplatePreview(template) {
            this.template = template;
            this.openPreview = true;
        }
    },
    watch: {
        category() {
            const that = this;
            this.swiper.destroy(true, true);
            this.swiper = null;
            this.swiper = new Swiper('.templates-swiper-container', {
                observer: true,
                observeParents: true,
                slidesPerView: 1,
                simulateTouch: false,
                keyboard: true,
                loop: true,
                pagination: {
                    el: '.templates-swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.templates-swiper-button-next',
                    prevEl: '.templates-swiper-button-prev'
                },
                on: {
                    slideNextTransitionStart() {
                        if (this.slides.length-1 === this.activeIndex) {
                            const categories = Object.keys(that.templates);
                            const currentIndex = categories.findIndex(cat => cat === that.category);
                            let newIndex = currentIndex + 1;
                            if (newIndex === categories.length) {
                                newIndex = 0;
                            }
                            that.category = categories[newIndex];
                        }
                    },
                    slidePrevTransitionStart() {
                        if (this.activeIndex === 0) {
                            const categories = Object.keys(that.templates);
                            const currentIndex = categories.findIndex(cat => cat === that.category);
                            let newIndex = currentIndex - 1;
                            if (newIndex === -1) {
                                newIndex = categories.length -1;
                            }
                            that.category = categories[newIndex];
                            this.activeIndex = this.slides.length - 1;
                        }
                    }
                }
            });
        }
    },
    destroyed() {
        this.swiper.destroy();
        this.swiper = null;
    },
};
</script>
<style scoped lang="less">
.swiper-slide-next,
.swiper-slide-prev {
    opacity: 0;
    @media (max-width: 991px) {
        opacity: 1;
    }
}
h2 {
    @media (max-width: 768px) {
        margin-bottom: 30px !important;
    }
}
.template-cta {
    background-color: rgba(255,255,255,0.2);
    padding: 8px 10px 6px 10px;
    color: #fff;
    border-radius: 3px;
    align-items: center;
    text-decoration: none;
    display: flex;
    width: fit-content;
    cursor: pointer;
    font-weight: 600;
    transition: .15s;
    &:hover {
        background-color: #fff;
        color: #62647B;
    }
}
.swiper-pagination {
    cursor: pointer;
}
.template-slider-wrapper {
    padding: 45px;
    border-radius: 8px;
    background: linear-gradient(113.56deg, #111727 8.1%, #10172F 95.55%);
    @media (max-width: 991px) {
        padding: 20px 5px;
    }
}
.swiper-image {
    color: #fff;
    text-align: left;
    transition: 0s !important;
    transition: 0.4s;
    .row {
        margin-left: 0;
        margin-right: 0;
    }
    h3 {
        font-size: 40px;
        font-family: 'Avenir Next Bold';
        margin-bottom: 20px;
        color: #fff;
        @media (max-width: 991px) {
            font-size: 30px;
        }       
    }
}
.swiper-button-prev {
    left: -50px;
}
.swiper-button-next {
    right: -40px;
}
.swiper-button-prev .ic-arrow {
    transform: rotate(180deg);
}
.swiper-button-next .ic-arrow, .swiper-button-prev .ic-arrow {
    width: 40px;
    height: 40px;
    display: flex;
    background-color: transparent !important;
    border: unset !important;
    &:before {
        background-image: url('/img/special-offer/arrow-right.svg');
        content: "";
        width: 50px;
        height: 37px;
        background-size: contain;
        background-repeat: no-repeat;
    }
}
.templates-tab {
    border-bottom: 1px solid rgba(124, 128, 140, 0.45) !important;
    margin-right: 0 !important;
    border-radius: 0 !important;
    padding-bottom: 20px !important;
    height: fit-content !important;
    color: rgba(255, 255, 255, 0.48) !important;
}
.templates-tab.active {
    color: #fff !important;
    border-bottom: 3px solid #D60399 !important;
    background-color: unset !important;
}
.pre-formatted {
    white-space: pre-line;
    font-family: "Avenir Next Medium";
}
@media(min-width:990px){
    .home-organize-slider{
        display:block;
    }
    .organize-scroll {
        display:none;
    }
    .swiper-slide {
        width: 100%;
    }
}
@media(max-width:990px){
    .swiper-slide {
        width: 100%;
    }
    .arrows {
        display: none;
    }
}
.swiper-container {
    overflow: visible;
    @media (max-width: 991px) {
        max-width: 85%;
    }
}
.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: transparent !important;
    display: flex;
    justify-content: center;
    align-items: center;
}
.organize-scroll{
    position:relative;
    width: 100%;
    overflow: auto;
    margin-top:40px;
}
.scroll-single{
    flex:none;
    margin-left: 40px;
}
.scroll-single .slide-title{
    display: flex;
    justify-content: center;
}
.swiper-slide-active {
    background: linear-gradient(to left top, #6FCFEB, #C92C99, #592265, #131C34) !important;
    padding: 1px;
    border-radius: 8px;
    .row {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    .pre-formatted {
        font-size: 18px;
    }
    .swiper-image {
        opacity: 1;
        border-radius: 17.14px;
    }
}
.slider-title {
    color: #1f2243;
    font-size: 36px;
    line-height: 48px;
    text-align: center;
    margin-bottom: 30px;
    letter-spacing: 1px;
    font-family: "Avenir Next Medium"
}
.slide-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    padding: 10px;
    margin-bottom: 10px;
}
</style>
<style>
.swiper-pagination.organize{
    margin: 20px auto 0;
    text-align: center;
    position: relative;
}
.organize .swiper-pagination-bullet:active,
.organize .swiper-pagination-bullet-active:focus {
    outline:0;
}
.organize .swiper-pagination-bullet-active {
    background: #fff;
}
.organize .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    margin-right: 25px;
    background: #fff;
}
.swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 10px;
}
.swiper-button-prev {
    background-image: none;
    color: #8f90a1;
    font-size: 40px;
    position: absolute;
    right: 10px;
}
.swiper-button-prev:active {
    outline: none;
}
.swiper-button-prev:focus {
    outline: none;
}
.swiper-button-next {
    background-image: none;
    color: #8f90a1;
    font-size: 40px;
    position: absolute;
    right: 10px;
}
.swiper-button-next:focus {
    outline: none;
}
.swiper-button-next:active {
    outline: none;
}
</style>




// WEBPACK FOOTER //
// resources/js/frontend/components/DarkTemplatesSlider.vue